<template>
    <div class="push">
        <div class="push-bar">
            <div class="push-bar-left">
                <el-select style="margin-left: 10px;" v-model="pushStatus" placeholder="请选择状态" clearable>
                    <el-option v-for="item in pushStatusList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select style="margin-left: 10px;" v-model="pushType" placeholder="请选择推送类型" clearable>
                    <el-option v-for="item in pushTypeList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <!-- <el-date-picker style="margin-left: 10px;" v-model="duration" type="datetimerange"
                    value-format="timestamp" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']">
                </el-date-picker> -->
            </div>
        </div>
        <page-list-container :total="total" :pageSize="pageSize" :inputCurrentPage="currentPage"
            @onPageChange="onPageChange" @onSizeChange="onSizeChange">
            <div class="push-table">
                <el-table :data="dataArray" stripe style="width: 100%">
                    <el-table-column prop="gmtCreate" label="时间" min-width="150" />
                    <el-table-column prop="pushType" label="推送类型" min-width="150" show-overflow-tooltip />
                    <el-table-column prop="pushStatus" label="推送状态" min-width="120" />
                    <el-table-column prop="targetType" label="目标类型" min-width="100" />
                    <el-table-column prop="pushContent" label="相关内容" min-width="180" />
                    <el-table-column prop="hospitalName" label="相关机构" min-width="180" show-overflow-tooltip />
                    <el-table-column prop="pushMethod" label="推送方式" min-width="120" />
                </el-table>
            </div>
        </page-list-container>
    </div>
</template>

<script>
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import { DateTool } from "@js/date-tool.js";
import { Select, Option, Input, Table, TableColumn, Popover, Button } from 'element-ui'
import { PushItemModel } from "@c/operation-log/push/push-item-model.js";
import dayjs from "dayjs";
export default {
    components: {
        PageListContainer,
        ElSelect: Select,
        ELOption: Option,
        ElInput: Input,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElPopover: Popover,
        ElButton: Button,
    },
    props: {
        duration: Object,
    },

    data() {
        return {
            //筛选
            startTime: undefined,
            endTime: undefined,
            keyword: undefined,
            pushType: undefined,
            pushTypeList: [
                { label: '睡眠报告', value: 1 },
                { label: '重启提示', value: 5 },
            ],
            pushStatus: undefined,
            pushStatusList: window.PUSH_LOG_STATUS_TYPE,
            //列表
            dataArray: [],
            total: 0,
            pageSize: undefined,
            currentPage: 1,
            BLOOD_OXYGEN_LOG_SYSTEM_TYPE: window.BLOOD_OXYGEN_LOG_SYSTEM_TYPE,
            tableHeight: window.innerHeight - 200,
        };
    },

    computed: {
        hospitalId() {
            return this.$store.state.selectedHospital.hospitalid;
        },
    },

    watch: {
        duration(value) {
            if (value && value.startTime && value.endTime) {
                this.startTime = dayjs(value.startTime * 1000).format('YYYY-MM-DD HH:mm:ss')
                this.endTime = dayjs(value.endTime * 1000).format('YYYY-MM-DD HH:mm:ss')
            } else {
                this.startTime = undefined
                this.endTime = undefined
            }
            this.currentPage = 1;
            this.getLogList();
        },

        pushType() {
            this.currentPage = 1;
            this.getLogList();
        },

        pushStatus() {
            this.currentPage = 1;
            this.getLogList();
        },
        hospitalId() {
            this.currentPage = 1;
            this.getLogList();
        }
    },


    mounted() {
        this.pageSize = bestPageSizeComputer()
        this.getLogList();
        this.tableHeight = window.innerHeight - 200;
        console.log(this.tableHeight)
    },

    methods: {
        onSearchClick(keyword) {
            this.keyword = keyword
            this.currentPage = 1;
            this.getLogList();
        },

        //分页
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.getLogList();
        },

        onSizeChange(size) {
            this.pageSize = size
            this.currentPage = 1
            this.getLogList();
        },

        // method
        async getLogList() {
            this.selectedIndex = null;
            this.selectedModel = null;
            try {
                const params = {
                    "pageNum": this.currentPage,
                    "pageSize": this.pageSize,
                    pushType: this.pushType,
                    pushStatus: this.pushStatus,
                    hospitalId: this.hospitalId,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    keyword: this.keyword,
                };
                const data = await this.$api.sleepPushLogList(params);
                this.dataArray = data.list.map((item) => {
                    return new PushItemModel(item)
                })
                this.total = data.total;
            } catch (error) {
                this.$toast.showRed(error);
            }
        }
    },
};
</script>


<style lang="scss" scoped>
.push {
    font-size: 19px;
    width: 100%;

    &-bar {
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &-left {
            display: flex;
        }

    }

    &-table {
        display: flex;
        flex-direction: column;

        /deep/.el-table {
            font-size: 14px;
        }

        /deep/thead {
            th {
                background-color: #FAFAFA;
            }
        }

        &-cell-content {
            flex: 3;
            display: flex;
            flex-direction: column;

            >a {
                line-height: 30px;
            }
        }
    }
}
</style>